{
  "loading": "جار التحميل...",
  "placeholder": "حدد خيارًا..."
}
